export function Eyebrow({ children, className = "", testId }) {
  return (
    <div className={`eyebrow ${className}`} data-testid={testId}>
      <span>{children}</span>
    </div>
  );
}
